var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { QuestionAdornerViewModel } from "survey-creator-core";
import * as React from "react";
import { ReactMouseEvent } from "../events";
import { ReactElementFactory, attachKey2click, TitleElement } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
function QuestionElementContentFunc(props) {
    return props.element;
}
var QuestionElementContent = React.memo(QuestionElementContentFunc);
QuestionElementContent.displayName = "QuestionElementContent";
var QuestionAdornerComponent = /** @class */ (function (_super) {
    __extends(QuestionAdornerComponent, _super);
    function QuestionAdornerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    QuestionAdornerComponent.prototype.createModel = function (props) {
        if (this.model) {
            this.model.attachToUI(props.question, this.rootRef.current);
        }
        else {
            this.modelValue = this.createQuestionViewModel(props);
        }
    };
    QuestionAdornerComponent.prototype.createQuestionViewModel = function (props) {
        return new QuestionAdornerViewModel(props.componentData, props.question, null);
    };
    QuestionAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "componentData"];
    };
    Object.defineProperty(QuestionAdornerComponent.prototype, "model", {
        get: function () {
            return this.modelValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    QuestionAdornerComponent.prototype.renderElement = function () {
        var _this = this;
        var allowInteractions = this.model.element
            .isInteractiveDesignElement;
        var titleForCollapsedState = this.renderQuestionTitle();
        var content = this.renderContent(allowInteractions);
        return (React.createElement("div", { ref: this.rootRef, "data-sv-drop-target-survey-element": this.model.element.name || null, className: this.model.rootCss(), onDoubleClick: function (e) { allowInteractions && _this.model.dblclick(e.nativeEvent); e.stopPropagation(); }, onMouseLeave: function (e) { return allowInteractions && _this.model.hover(e.nativeEvent, e.currentTarget); }, onMouseOver: function (e) { return allowInteractions && _this.model.hover(e.nativeEvent, e.currentTarget); } },
            titleForCollapsedState,
            content));
    };
    QuestionAdornerComponent.prototype.disableTabStop = function () {
        return true;
    };
    QuestionAdornerComponent.prototype.renderContent = function (allowInteractions) {
        var _this = this;
        var content = this.model.needToRenderContent ? this.renderElementContent() : null;
        //if (!allowInteractions) return <>{content}{this.renderFooter()}</>;
        return attachKey2click(React.createElement("div", { className: this.model.css(), onClick: function (e) { return _this.model.select(_this.model, new ReactMouseEvent(e)); } },
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--left" }),
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--right" }),
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--top" }),
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }),
            allowInteractions ? this.renderHeader() : null,
            content,
            this.model.needToRenderContent ? this.renderFooter() : null), undefined, { disableTabStop: this.disableTabStop() });
    };
    QuestionAdornerComponent.prototype.renderHeader = function () {
        return ReactElementFactory.Instance.createElement("svc-question-header", { model: this.model });
    };
    QuestionAdornerComponent.prototype.renderFooter = function () {
        var allowInteractions = this.model.element
            .isInteractiveDesignElement;
        return allowInteractions ? ReactElementFactory.Instance.createElement("svc-question-footer", { className: "svc-question__content-actions", model: this.model }) : null;
    };
    QuestionAdornerComponent.prototype.renderCarryForwardBanner = function () {
        if (!this.model.isBannerShowing)
            return null;
        return ReactElementFactory.Instance.createElement("svc-question-banner", this.model.createBannerParams());
    };
    QuestionAdornerComponent.prototype.renderQuestionTitle = function () {
        var _this = this;
        if (!this.model.showHiddenTitle)
            return null;
        var element = this.model.element;
        return (React.createElement("div", { ref: function (node) { return node && (!_this.model.renderedCollapsed ?
                node.setAttribute("inert", "") : node.removeAttribute("inert")); }, className: this.model.cssCollapsedHiddenHeader }, (element.hasTitle ?
            React.createElement(TitleElement, { element: element, renderActions: false }) :
            React.createElement("div", { className: this.model.cssCollapsedHiddenTitle },
                React.createElement("span", { className: "svc-fake-title" }, element.name)))));
    };
    QuestionAdornerComponent.prototype.renderElementContent = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(QuestionElementContent, { element: this.props.element }),
            this.renderElementPlaceholder(),
            this.renderCarryForwardBanner()));
    };
    QuestionAdornerComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.attachToUI(this.props.question, this.rootRef.current);
    };
    QuestionAdornerComponent.prototype.renderElementPlaceholder = function () {
        if (!this.model.isEmptyElement) {
            return null;
        }
        return (React.createElement("div", { className: "svc-panel__placeholder_frame-wrapper" },
            React.createElement("div", { className: "svc-panel__placeholder_frame" },
                React.createElement("div", { className: "svc-panel__placeholder" }, this.model.placeholderText))));
    };
    QuestionAdornerComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.detachFromUI();
    };
    return QuestionAdornerComponent;
}(CreatorModelElement));
export { QuestionAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-question", function (props) {
    return React.createElement(QuestionAdornerComponent, props);
});
